import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import DesktopNav, { NavbarTopBar } from "./NavbarDesktop";
import MobileNav from "./NavbarMobile";

function Navbar() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const changeLanguage = (lng) => {
    const normalized = String(lng || "me").toLowerCase().startsWith("en") ? "en" : "me";
    const params = new URLSearchParams(location.search);

    if (normalized === "en") {
      params.set("lang", "en");
    } else {
      params.delete("lang");
    }

    const query = params.toString();
    navigate(`${location.pathname}${query ? `?${query}` : ""}${location.hash || ""}`, { replace: true });
    i18n.changeLanguage(normalized);
  };
  const currentLanguage = i18n.language;

  const isEnglishLanguage = String(currentLanguage || "me").toLowerCase().startsWith("en");
  const logoSrc = isEnglishLanguage
    ? "/assets/img/logo/logoENG.png"
    : "/assets/img/logo/logo.png";

  return (
    <>
      <header className="header-area header-three">
        {/* Desktop top bar */}
        <NavbarTopBar t={t} />

        {/* Sticky main header */}
        <div
          id="header-sticky"
          className={`menu-area${isScrolled ? " menu-area sticky-menu" : ""}`}
        >
          <div className="container">
            <div className="second-menu">
              <div className="row align-items-center">
                {/* Logo */}
                <div className="col-xl-3 col-lg-3">
                  <div className="logo">
                    <Link to="/">
                      <img src={logoSrc} alt="logo" />
                    </Link>
                  </div>
                </div>

                {/* Desktop navigation */}
                <DesktopNav
                  t={t}
                  currentLanguage={currentLanguage}
                  changeLanguage={changeLanguage}
                />

                {/* Mobile navigation */}
                <MobileNav
                  t={t}
                  currentLanguage={currentLanguage}
                  changeLanguage={changeLanguage}
                />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Navbar;
